module.exports = __webpack_public_path__ + "static/media/mijue8.eab52a1d.png";